import React, { useState } from "react";
import ClipLoader from 'react-spinners/ClipLoader';
import { addDoc, collection, db } from "../../firebase"; // Ajusta la ruta si es necesario

import { toast } from "react-toastify";

const PwSection = (props) => {

  const [isLoading, setIsLoading] = useState(false);  // Estado para el loader

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    assistants: 1,
  });

  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setIsLoading(true);
      // Guardar los datos en Firebase Firestore
      await addDoc(collection(db, "PreWedding"), {
        name: formData.name || "",
        phone: formData.phone || "",
        assistants: formData.assistants || 1,
        timestamp: new Date(), // Fecha de envío
      });

      // Desplazarse al elemento con id "campo-nombre"
      const elemento = document.getElementById("preboda");
      if (elemento) {
        const posicion = elemento.getBoundingClientRect().top + window.scrollY; // Calcula la posición en la página
        window.scrollTo({
          top: posicion - "0", // Aplica el offset restándolo
          behavior: "smooth", // Desplazamiento suave
        });
      }
      setFormSubmitted(true);
    } catch (error) {
      toast.error('Ha habido un error en el envío', {
        position: "top-center", // Posición central superior
        autoClose: 3000, // Tiempo de duración (en milisegundos)
        hideProgressBar: true, // Mostrar barra de progreso
        closeOnClick: true, // Cierre al hacer clic
        pauseOnHover: true, // Pausa al pasar el cursor
        draggable: true, // Permitir arrastrar el toast
        progress: undefined, // Barra de progreso predeterminada
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className={`section-padding`} id="preboda">
      {/* Mostrar el loader mientras isLoading sea verdadero */}
      {isLoading && (
        <div className="loader-overlay">
          <ClipLoader color="#fff" loading={isLoading} size={50} />
        </div>
      )}
      <div className="wpo-cta-section wpo-pw-section">
        <div className="conatiner-fluid">
          <div className="wpo-cta-item">
            <h2>Preboda</h2>
            <p className="p-0 m-0" style={{ color: 'white' }}>20 de Junio, 20:00</p>
          </div>
        </div>
      </div>
      <div className="container">
        {formSubmitted ? (<div style={{ textAlign: "center", marginTop: "50px" }}>
          <h2>¡Gracias por unirte a la preboda! 📝</h2>
          <br></br>
          <p>Tu solicitud ha sido procesada correctamente. Pronto recibirás más información. ¡Prepárate para una noche divertida y llena de buenos momentos! 😊</p>
        </div>) :

          (<div className="flex mt-5 px-4">
            <div className="col-12 col-lg-6 mx-auto">
              <h1 className="mb-4">📢 ¡La Preboda del Año! 🎉</h1>
              <p>Antes de que la cosa se ponga seria en la boda, queremos que todos os conozcáis y rompáis el hielo… ¡o al menos lo agrietéis un poco! 🧊🔨</p>
              <p>Os invitamos a un <strong>pica-pica</strong> para que podáis llenar el estómago mientras cotilleáis quién es quién. No queremos que el día de la boda alguien pregunte: <em>“¿Y este quién es? ¿El primo del cuñado del vecino?”</em></p>
              {/* <p>Además, tenemos preparados algunos <strong>juegos</strong> para que no os quedéis solo con la excusa del “¿Y tú de quién eres?” y podáis empezar a forjar alianzas… o al menos encontrar un compañero de baile para la boda. 💃🕺</p>
              <p>Así que venid con ganas de pasarlo bien, de conocer gente y, sobre todo, de entrenar para la boda, que esto es solo el <strong>calentamiento</strong>. 🔥😆</p> */}
              <p>El evento será en Jaén, cerca del centro, para que, si la cosa se anima, quien quiera pueda seguir la fiesta sin problemas. 🕺💃 </p>
              <p>Para los que quieran estar al tanto de todos los detalles de la preboda, apuntaros a la lista y os meteremos en un grupo de WhatsApp donde daremos la ubicación final.🎊</p>
              <p>¡Nos vemos ahí! 🥳</p>

              <form onSubmit={handleSubmit} className="card shadow p-4" style={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                marginTop: "20px",
                backgroundColor: "#94683d17",  // Fondo claro que combina con #94683d
                border: "1px solid #94683d",  // Borde en el color principal
                borderRadius: "10px",
                margin: "0 auto",
                color: "#94683d"  // Color de texto oscuro que combina con #94683d
              }}>
                <label style={{ fontSize: "18px", fontWeight: "500" }}>
                  Nombre:
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Tu nombre completo"
                    style={{
                      width: "100%",
                      padding: "10px",
                      marginTop: "5px",
                      border: "1px solid #94683d",
                      borderRadius: "5px",
                      fontSize: "16px",
                      fontFamily: "'Roboto', sans-serif",
                      backgroundColor: "#ffffff",  // Fondo blanco para los inputs
                      color: "#94683d"  // Color de texto oscuro
                    }}
                  />
                </label>

                <label style={{ fontSize: "18px", fontWeight: "500" }}>
                  Teléfono:
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    placeholder="Tu número de teléfono"
                    style={{
                      width: "100%",
                      padding: "10px",
                      marginTop: "5px",
                      border: "1px solid #94683d",
                      borderRadius: "5px",
                      fontSize: "16px",
                      fontFamily: "'Roboto', sans-serif",
                      backgroundColor: "#ffffff",  // Fondo blanco para los inputs
                      color: "#94683d"  // Color de texto oscuro
                    }}
                  />
                </label>

                <label style={{ fontSize: "18px", fontWeight: "500" }}>
                  ¿Cuántos seréis?
                  <input
                    type="number"
                    name="assistants"
                    value={formData.assistants}
                    onChange={handleChange}
                    min="1"
                    required
                    style={{
                      width: "100%",
                      padding: "10px",
                      marginTop: "5px",
                      border: "1px solid #94683d",
                      borderRadius: "5px",
                      fontSize: "16px",
                      fontFamily: "'Roboto', sans-serif",
                      backgroundColor: "#ffffff",  // Fondo blanco para los inputs
                      color: "#94683d"  // Color de texto oscuro
                    }}
                  />
                </label>

                <button
                  type="submit"
                  style={{
                    padding: "12px 24px",
                    backgroundColor: "#94683d",  // Color principal
                    color: "white",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                    fontSize: "18px",
                    fontWeight: "500",
                    transition: "background-color 0.3s ease",
                    marginTop: "10px"
                  }}
                  onMouseOver={(e) => e.target.style.backgroundColor = "#814913"}  // Oscurece al pasar el mouse
                  onMouseOut={(e) => e.target.style.backgroundColor = "#94683d"}  // Vuelve al color original
                >
                  Me apunto! 
                </button>
              </form>
            </div>
          </div>)}
      </div>
    </section>

  );
};

export default PwSection;
